import type React from 'react';

import * as styles from './styles';

import { CaptionDefault } from '@cobliteam/base-components';

import Icon from '@cobliteam/ui/icons';

const OdometerWarningBanner: React.FC = () => (
  <div className={styles.banner}>
    <Icon name='triangle-alert' className={styles.warningIcon} />
    <CaptionDefault>
      As mudanças nas informações de odômetro feitas na aba de veículos não alteram o prazo dos lembretes de manutenção cadastrados aqui. Para atualizar os lembretes clique em
      "Configurar” e depois em ”Editar lembretes".
    </CaptionDefault>
  </div>
);

export default OdometerWarningBanner;
